export default function CFree() {
  return <h2>C Free</h2>;
}
